import { Campaign } from '@/services/campaigns.service';

interface Props { campaign: Campaign; }

export const CampaignProgress: React.FC<Props> = ({ campaign }) => {
  const total = Math.max(1, campaign.totalRecipients);
  const sentPct = Math.round((campaign.sent / total) * 100);
  const deliveredPct = Math.round((campaign.delivered / total) * 100);
  const readPct = Math.round((campaign.read / total) * 100);
  const failedPct = Math.round((campaign.failed / total) * 100);

  return (
    <div className="space-y-3">
      <div className="grid grid-cols-5 gap-3 text-center">
        <Stat label="Total" value={campaign.totalRecipients} />
        <Stat label="Sent" value={campaign.sent} accent="primary" />
        <Stat label="Delivered" value={campaign.delivered} accent="info" />
        <Stat label="Read" value={campaign.read} accent="success" />
        <Stat label="Failed" value={campaign.failed} accent="danger" />
      </div>

      <div>
        <div className="text-xs text-text-muted mb-1 flex justify-between">
          <span>Progress</span>
          <span>{sentPct}% sent · {deliveredPct}% delivered · {readPct}% read · {failedPct}% failed</span>
        </div>
        <div className="h-2 rounded-full bg-surface-alt overflow-hidden flex">
          <div className="h-full bg-success" style={{ width: `${readPct}%` }} title="Read" />
          <div className="h-full bg-info" style={{ width: `${Math.max(0, deliveredPct - readPct)}%` }} title="Delivered" />
          <div className="h-full bg-primary" style={{ width: `${Math.max(0, sentPct - deliveredPct)}%` }} title="Sent" />
          <div className="h-full bg-danger" style={{ width: `${failedPct}%` }} title="Failed" />
        </div>
      </div>
    </div>
  );
};

const Stat: React.FC<{ label: string; value: number; accent?: 'primary' | 'info' | 'success' | 'danger' }> = ({ label, value, accent }) => {
  const color = accent === 'primary' ? 'text-primary'
    : accent === 'info' ? 'text-info'
    : accent === 'success' ? 'text-success'
    : accent === 'danger' ? 'text-danger'
    : 'text-text-primary';
  return (
    <div className="bg-surface border border-border rounded-lg p-3">
      <div className="text-[10px] uppercase text-text-muted">{label}</div>
      <div className={`text-xl font-bold mt-1 ${color}`}>{value}</div>
    </div>
  );
};
